import React from 'react';
import { getOperationalMetricMeta } from '../../../constants/operationalMetricCatalog';
import { formatScalarMetricValue } from './metricFormat';
import { KpiCard, KpiHint, KpiLabel, KpiValue } from './styles';

/**
 * @param {{ metricKey: string, data?: { rate?: number | null, value?: number | null, numerator?: number, denominator?: number }, loading?: boolean, compact?: boolean }} props
 */
export default function RateMetricCard({ metricKey, data = {}, loading = false, compact = false }) {
    const { label } = getOperationalMetricMeta(metricKey);
    const rate = data.rate ?? data.value;
    const hasSample = rate != null && Number(data.denominator) > 0;
    const display = loading ? '—' : hasSample ? formatScalarMetricValue(metricKey, rate) : 'Sem dados';
    const fraction = !loading && hasSample
        ? `${Number(data.numerator).toLocaleString('pt-BR')}/${Number(data.denominator).toLocaleString('pt-BR')}`
        : null;

    if (compact) {
        return (
            <KpiCard aria-label={label} title={fraction || undefined}>
                <KpiLabel>{label}</KpiLabel>
                <KpiValue>{display}</KpiValue>
                {fraction ? <KpiHint>{fraction}</KpiHint> : null}
            </KpiCard>
        );
    }

    return (
        <div>
            <KpiValue>{display}</KpiValue>
            {fraction ? <KpiHint>{fraction}</KpiHint> : null}
        </div>
    );
}
